(function () {
  'use strict';

  /**
   * Re-renders the cart-drawer using Shopify Section Rendering API
   * and keeps the drawer open.
   */
  async function refreshCartDrawer() {
    const res = await fetch('/?sections=cart-drawer', {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('Section render failed: ' + res.status);
    const sections = await res.json();
    const html = sections['cart-drawer'];
    if (!html) throw new Error('cart-drawer section not returned');

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newDrawer = doc.querySelector('cart-drawer, #cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer, #cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    } else {
      location.reload();
    }

    // Notify rest of theme (header count, etc.)
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  /** Handle REMOVE button clicks */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();

    const line = parseInt(btn.dataset.lineIndex, 10);
    if (!line) return;

    btn.disabled = true;
    btn.style.opacity = '0.5';

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line: line, quantity: 0 }),
      });
      if (!res.ok) throw new Error('Cart change failed: ' + res.status);

      await refreshCartDrawer();
    } catch (err) {
      console.error('[cart-drawer-ajax] Remove failed:', err);
      btn.disabled = false;
      btn.style.opacity = '1';
      // Fallback: navigate to /cart page
      location.href = '/cart';
    }
  });

  /** Handle QUANTITY +/- button clicks (data-action="increase|decrease") */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-action="increase"], [data-action="decrease"]');
    if (!btn) return;
    // Only handle buttons inside our cart drawer (not other qty pickers)
    if (!btn.closest('cart-drawer, #cart-drawer')) return;
    e.preventDefault();

    const line = parseInt(btn.dataset.line, 10);
    if (!line) return;

    const qtySpan = btn.closest('.hh-qty-pill')?.querySelector('.hh-qty-val');
    const currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 0;
    const delta = btn.dataset.action === 'increase' ? 1 : -1;
    const newQty = Math.max(0, currentQty + delta);

    // Disable controls while updating
    const pill = btn.closest('.hh-qty-pill');
    if (pill) pill.style.opacity = '0.5';

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line: line, quantity: newQty }),
      });
      if (!res.ok) throw new Error('Cart change failed: ' + res.status);

      await refreshCartDrawer();
    } catch (err) {
      console.error('[cart-drawer-ajax] Quantity change failed:', err);
      if (pill) pill.style.opacity = '1';
    }
  });

  /** Handle SUBSCRIPTION UPGRADE button — converts paid items to selling_plan */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-subscription-upgrade]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    const sellingPlanId = parseInt(btn.dataset.sellingPlan, 10);
    if (!sellingPlanId) {
      console.error('[subscription-upgrade] missing or invalid data-selling-plan');
      return;
    }

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.dataset.busy = '1';
    btn.textContent = 'Wird umgestellt…';

    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json());

      // Process all paid items that aren't already on a subscription.
      // /cart.js doesn't populate selling_plan_allocations on line items, so we
      // attempt the change and treat Shopify's 422 (variant not eligible) as soft skip.
      const candidateIndexes = [];
      cart.items.forEach((item, idx) => {
        if (item.final_price <= 0) return;
        if (item.selling_plan_allocation) return;
        candidateIndexes.push(idx);
      });

      if (candidateIndexes.length === 0) {
        throw new Error('No paid non-subscription items');
      }

      let successCount = 0;
      let lastErrorBody = null;

      for (const idx of candidateIndexes) {
        const item = cart.items[idx];
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: idx + 1,
            quantity: item.quantity,
            selling_plan: sellingPlanId,
          }),
        });
        if (res.ok) {
          successCount += 1;
        } else {
          lastErrorBody = await res.text();
          console.warn('[subscription-upgrade] line skipped', idx + 1, res.status, lastErrorBody);
        }
      }

      if (successCount === 0) {
        throw new Error('All change.js calls failed: ' + lastErrorBody);
      }

      await refreshCartDrawer();
    } catch (err) {
      console.error('[subscription-upgrade] failed', err);
      btn.disabled = false;
      btn.textContent = originalText;
      delete btn.dataset.busy;
      alert('Upgrade konnte nicht durchgeführt werden. Bitte versuche es erneut oder kontaktiere uns.');
    }
  });

  /**
   * Intercept add-to-cart (Horizon ATC, Kaching bundles, featured-product, etc.)
   * All of them POST to /cart/add[.js]. After a successful add we re-render the
   * drawer via the Section Rendering API and slide it open.
   */
  const _hhOrigFetch = window.fetch;
  window.fetch = function () {
    const a0 = arguments[0];
    const url = (a0 && a0.url) ? a0.url : ('' + a0);
    const isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    const p = _hhOrigFetch.apply(this, arguments);
    if (!isAdd) return p;
    return p.then(function (res) {
      if (res && res.ok) {
        setTimeout(function () {
          refreshCartDrawer()
            .then(function () {
              const d = document.querySelector('cart-drawer#cart-drawer, cart-drawer, #cart-drawer');
              if (d && typeof d.open === 'function') d.open();
            })
            .catch(function () {});
        }, 200);
      }
      return res;
    });
  };
})();
